


















































import Vue from 'vue';
import { get } from 'vuex-pathify';
// Utilities
import { genChip } from '@/utils/componentHelpers';
import ListItem from './ListItem.vue';
import SubGroup from './SubGroup.vue';

export default Vue.extend({
  name: 'Group',

  inheritAttrs: false,

  components: { ListItem, SubGroup },

  props: {
    item: {
      type: Object,
      default: () => ({
        chip: '',
        text: '',
        group: '',
        children: []
      })
    },
    subGroup: {
      type: Boolean,
      default: false
    },
    actionIcon: {
      type: [Boolean, String],
      default: false
    },
    chip: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    list: null
  }),
  methods: {
    genChip
  },
  computed: {
    mini: get('app/mini'),
    children() {
      return this.item.children;
    },
    chipColor() {
      switch (this.item.chip) {
        case 'new':
          return 'primary';
        case 'updated':
          return 'warning';
        case 'deprecated':
          return 'black';
        case 'help':
          return 'error';
        case 'dev':
          return 'secondary';
        default:
          return 'primary';
      }
    }
  }
});
